import { Component, OnInit } from '@angular/core';
import {UtilService} from "../../services/utilService/util.service";
import { environment as ENV } from '../../../environments/environment';
import {SuperAdminService} from "../../services/apiCalls/superAdminService/super-admin.service";
import {IResponse} from "../../interfaces/iresponse";
import {UserService} from "../../services/apiCalls/userService/user.service";
import {BootstrapNotifyService} from "../../services/bootstrap-notify/bootstrap-notify.service";
import { genderType } from 'src/app/users/enrol-riders/enrol-riders.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-super-agents',
  templateUrl: './super-agents.component.html',
  styleUrls: ['./super-agents.component.css']
})
export class SuperAgentsComponent implements OnInit {
  breadCrumb: any;
  disabled: boolean = false;
  superAgentId: number = 0;
  public EMAIL_VALIDATION: any =  ENV.EMAIL_VALIDATION;
  loaders = {
    saving: false
  };
  allZones: any[] = [];
  superAgent =  {
    first_name: null,
    last_name: null,
    email: null,
    phone_no: null,
    password: 'password',
    password_confirmation: 'password',
    zone_id: null
  };
  activeSAgent = null;
  public allSuperAgents: any[] = [];
  public loadingData = false;
  public modal = {
    title: 'Create Super Agent',
    btnText: 'SAVE'
  };
  currentPage: number = 1;
  perPage: number = 10;
  filterZoneBy: genderType[] = [
      {id: 1, value: '', name: 'Filter By Status'},
      {id: 1, value: '1', name: 'All'},
      {id: 1, value: 'active', name: 'Active'},
      {id: 1, value: 'inactive', name: 'InActive'},
    ];
    
    filterForm = new FormGroup({
      status: new FormControl('', Validators.required)
    })
  constructor(private utilService: UtilService,
              private superAdminService: SuperAdminService,
              private userService: UserService,
              private bootstrapNotify: BootstrapNotifyService) { }

  ngOnInit() {
    this.breadCrumb  = {
      name: 'Super Agents',
      parent: 'Home',
      subLink: null
    };
    this.getAllSuperAgents();
    this.getZones();
  }
  openDialog(id) {
    this.modal = {
      title: 'Create Super Agent',
      btnText: 'SAVE'
    };
    this.activeSAgent = null;
    this.resetForm();
    this.utilService.openModal(id);
  }

  public triggerEdit(superAgent){
    this.activeSAgent = JSON.parse(JSON.stringify(superAgent));
    this.resetForm();
    this.utilService.openModal('createSuperAgent');
    this.superAgent = this.activeSAgent;
    this.modal = {
      title: 'Update Super Agent',
      btnText: 'UPDATE'
    };
  }

  getAllSuperAgents() {
    this.loadingData = true;
    const filterStatus = this.filterForm.get('status').value;
    this.superAdminService.getAllSuperAgents(filterStatus, this.currentPage, this.perPage)
      .subscribe((res: IResponse) => {
        this.allSuperAgents = res.data.data;
        this.utilService.startDatatable('super-agents-list');
        this.loadingData = false;
      }, error => {
        this.utilService.startDatatable('super-agents-list');
        this.loadingData = false;
      });
  }

  public createSuperAgent() {
    this.loaders.saving = true;
    if (!this.superAgent.email) {
      this.bootstrapNotify.info('Super Agent Email is Required');
      this.loaders.saving = false;
    } else if (!this.superAgent.phone_no) {
      this.bootstrapNotify.info('Super Agent Phone Number is Required');
      this.loaders.saving = false;
    } else if (!this.superAgent.first_name) {
      this.bootstrapNotify.info('Super Agent First Name is Required');
      this.loaders.saving = false;
    } else if (!this.superAgent.last_name) {
      this.bootstrapNotify.info('Super Agent Last Name is Required');
      this.loaders.saving = false;
    } else if (!this.superAgent.password && !this.activeSAgent) {
      this.bootstrapNotify.info('Enter a secure password');
      this.loaders.saving = false;
    }  else if (this.superAgent.password !== this.superAgent.password_confirmation && !this.activeSAgent) {
      this.bootstrapNotify.info('Password must match!');
      this.loaders.saving = false;
    } else if (!this.superAgent.zone_id || this.superAgent.zone_id === 'undefined') {
      this.bootstrapNotify.info('Select your local government!');
      this.loaders.saving = false;
    } else {
      if(this.activeSAgent) {
        this.updateSuperAgent();
      } else {
        this.superAdminService.createSuperAgents(this.superAgent).subscribe((response: IResponse) => {
          this.loaders.saving = false;
          this.resetForm();
          this.getAllSuperAgents();
          this.utilService.closeModal('createSuperAgent');
          this.bootstrapNotify.success(response.message || 'Super agent created successfully!', 'right');
        }, error => {
          this.bootstrapNotify.error(error.error.message || 'Unable to create super agent!', 'right');
          this.loaders.saving = false;
        });
      }

    }
  }
  public updateSuperAgent() {
    delete this.superAgent.password;
    delete this.superAgent.password_confirmation;
    const {first_name, last_name, zone_id, phone_no, email} = this.superAgent;
    const payload  = {
      first_name, last_name,
      zone_id, phone_no, email
    }
    this.superAdminService.updateSuperAgents(payload, this.activeSAgent.id).subscribe((response: IResponse) => {
      this.loaders.saving = false;
      this.resetForm();
      this.getAllSuperAgents();
      this.utilService.closeModal('createSuperAgent');
      this.bootstrapNotify.success(response.message || 'Super agent updated successfully!', 'right');
    }, error => {
      this.bootstrapNotify.error(error.error.message || 'Unable to update super agent!', 'right');
      this.loaders.saving = false;
    });
  }

  public resetForm() {
    this.superAgent = {
      first_name: null,
      last_name: null,
      email: null,
      phone_no: null,
      password: 'password',
      password_confirmation: 'password',
      zone_id: null
    };
  }
  public getZones() {
    this.userService.getAllZones('').subscribe(res => {
      this.allZones = res.data;
    }, error => {
    })
  }
  public deleteSuperAgent(superAgent) {
    this.disabled = true;
    this.superAgentId = superAgent?.id;

    this.utilService.confirmAction(() => {
      this.superAdminService.deleteSuperAgent(superAgent.id)
        .subscribe((res: IResponse) => {
          this.getAllSuperAgents();
        }, error => {
          this.bootstrapNotify.error(error.error.message);
        }).add(()=> this.disabled = false);
    }, ()=>{
      this.superAgentId = 0;
      this.disabled = false
    })
  }

  public toggleSuperAgentStatus(superAgent){
    this.disabled = true;
    this.superAgentId = superAgent?.id;

    const action = superAgent.status === 'Active' ? 'disable' : 'enable';

    this.utilService.confirmAction(() => {
      this.superAdminService.toggleSuperAgentStatus(superAgent.id, action).subscribe((res: IResponse) => {
        this.getAllSuperAgents();
        this.bootstrapNotify.success(res.message || `Super agent ${action}d successfully!`, 'right');
      }, error => {
        this.bootstrapNotify.error(error.error.message);
      }).add(() => this.disabled = false);
    }, () => {
      this.superAgentId = 0;
      this.disabled = false;
    });
  }

  onFilterBy(){
    if(this.filterForm.invalid) return;
    this.getAllSuperAgents();
  }

}
